module.exports = __webpack_public_path__ + "assets/img/bg-05.f4bc680a.jpg";